import { useEffect } from 'react';

interface UseControlBodyOverflowProps {
  open: boolean;
  isMobile: boolean;
}

function useControlBodyOverflow({
  open,
  isMobile,
}: UseControlBodyOverflowProps): void {
  useEffect(() => {
    if (open && !isMobile) {
      document.body.classList.add('body-overflow-auto');
    }

    function restoreBodyStyles(): void {
      document.body.classList.remove('body-overflow-auto');
    }

    if (!open) {
      restoreBodyStyles();
    }

    return () => {
      restoreBodyStyles();
    };
  }, [open, isMobile]);
}

export default useControlBodyOverflow;
